/**
 * Bump whenever buildLap or anything upstream of it changes what a lap
 * contains. Consumers that persist processed laps (the mobile lap cache)
 * key on it, and the contract test pins a fingerprint per version.
 */
export const LAP_PROCESSING_VERSION = 7
